<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="时间:">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker></el-form-item
        ><br />
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-input v-model="searchValue.zone_name"></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-radio
            v-model="searchValue.is_zone"
            :checked="searchValue.is_zone == 0 ? 0 : 1"
            :label="1"
            >不分区服</el-radio
          > -->
          <el-checkbox v-model="checked">不分区服</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchRechargeList">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportMonthSummary()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :summary-method="getSummaries"
      show-summary
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="hourdate" label="时间" width="100" fixed> </el-table-column>
      <el-table-column prop="user_role.zone_name" label="区服">
      </el-table-column>
      <el-table-column prop="downloads" label="下载数"> </el-table-column>
      <el-table-column prop="actives" label="激活数"> </el-table-column>
      <el-table-column prop="down_actives" label="下载激活率">
        <template slot-scope="scope"> {{ scope.row.down_actives }}% </template>
      </el-table-column>
      <el-table-column prop="reg_num" label="注册数"> </el-table-column>
      <el-table-column prop="reg_chain_ratio" label="注册环比">
        <template slot-scope="scope">
          {{ scope.row.reg_chain_ratio }}%
        </template>
      </el-table-column>
      <el-table-column prop="active_reg_rate" label="激活注册率">
        <template slot-scope="scope">
          {{ scope.row.active_reg_rate }}%
        </template>
      </el-table-column>
      <el-table-column prop="first_money_num" label="新增充值人数">
      </el-table-column>
      <el-table-column prop="pay_num" label="活跃充值人数"> </el-table-column>
      <el-table-column prop="new_first_money" label="新增充值总额">
      </el-table-column>
      <el-table-column prop="money" label="充值总额"> </el-table-column>
      <el-table-column prop="first_pay_rate" label="新增付费率">
        <template slot-scope="scope">
          {{ scope.row.first_pay_rate }}%
        </template>
      </el-table-column>
      <el-table-column prop="new_first_arpu" label="新增arpu">
      </el-table-column>
      <el-table-column prop="arppu" label="付费arppu"> </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "hourDataReport",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        game_id: "",
        zone_name: "",
        created_from: "",
        created_to: "",
        is_zone: "",
      },
      value1: [],
      checked: false,
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      gamesList: [],
      collect: [],
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    let dateStart = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    let systemTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");

    this.value1[0] = dateStart;
    this.value1[1] = systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];

    this.getGameSelectList();
    this.getHourDataReport(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getHourDataReport(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getHourDataReport(false);
    },

    // 导出
    exportMonthSummary() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/statistics/hour_data_report", params);
    },
    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },
    // 实现渠道包数据的搜索
    searchRechargeList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      if (this.checked == false) {
        this.searchValue.is_zone = 0;
      } else {
        this.searchValue.is_zone = 1;
      }
      this.currentPage = 1;
      this.getHourDataReport(true);
    },
    // endTime() {
    //   let systemTime = moment().endOf("day").format("HH:mm:ss");
    // },
    // 展示用户角色列表数据
    getHourDataReport(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/statistics/hour_data_report",
        method: "GET",
        params: {
          ...searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data[0].data;
            this.collect = res.data.data.collect;
            this.totalRecords = res.data.data[0].total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },

    // 数据统计
    getSummaries(param) {
      let arr = [];
      arr[0] = "合计";
      arr[1] = "";
      arr[2] = this.collect.downloads;
      arr[3] = this.collect.actives;
      arr[4] = this.collect.down_actives + "%";
      arr[5] = this.collect.reg_num;
      arr[6] = this.collect.reg_chain_ratio + "%";
      arr[7] = this.collect.active_reg_rate + "%";
      arr[8] = this.collect.first_money_num;
      arr[9] = this.collect.pay_num;
      arr[10] = this.collect.new_first_money;
      arr[11] = this.collect.money;
      arr[12] = this.collect.first_pay_rate + "%";
      arr[13] = this.collect.new_first_arpu;
      arr[14] = this.collect.arppu;
      return arr;
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.endTime {
  margin-left: 10px;
}
</style>
